import {
  PageEntityInterface,
  WithChildIdsInterface,
} from '../types/base-entity-interface'

export function isEntityWithChildIds(
  entity: PageEntityInterface,
): entity is WithChildIdsInterface {
  return 'childIds' in entity
}
